export default __webpack_public_path__ + "static/media/sector18.f4189b21.jpg";